import matchMyPetImg from "../assets/img/matchmypet.webp";
import imoveisImg from "../assets/img/imoveis-mendicino.webp";
import boizapImg from "../assets/img/boizap-infra.webp";
import purgatumImg from "../assets/img/purgatum-logo.webp";
import videosciiImg from "../assets/img/videosciijotaro.webp";

export const profile = {
  name: "Pedro Pampolini Mendicino",
  email: "pedromendicino25@gmail.com",
  linkedin: "https://www.linkedin.com/in/pedro-mendicino-2a6751190/",
  github: "https://github.com/PedroPampolini",
  instagram: "https://www.instagram.com/pampolinipedro/",
};

export const stats = [
  { value: "200k", unit: "req/s", label: "Pico de tráfego em uma plataforma de notificações" },
  { value: "8M+", unit: "", label: "Usuários atendidos pelos serviços que construí" },
  { value: "60k", unit: "req/s", label: "Comunicação personalizada com testes A/B" },
  { value: "<20", unit: "ms", label: "Motor de cálculo em Go com grafos" },
];

export const experiences = [
  {
    company: "Levty",
    role: "Software Developer",
    period: "ago/2026 – atual",
    context: "Consultoria de transformação digital e automação de processos.",
    highlights: [
      "Desenvolvo aplicações corporativas e automações de processos na plataforma low-code SYDLE ONE: workflows, regras de negócio, validações, integrações, modelagem de dados e lógica de backend em JavaScript.",
    ],
    tags: ["JavaScript", "SYDLE ONE", "Integrações", "Modelagem de dados"],
  },
  {
    company: "NG.CASH",
    role: "Full-Stack Developer",
    period: "ago/2024 – jun/2026",
    context: "Banco digital da Geração Z com mais de 8 milhões de usuários.",
    highlights: [
      "Construí a plataforma de notificações multicanal (e-mail, push, SMS e in-app), integrada a provedores externos e preparada para picos de 200 mil requisições por segundo.",
      "Desenvolvi o serviço de comunicação personalizada no app, que escolhe mensagens por atributos do usuário para milhões de pessoas, com picos de 60 mil req/s e testes A/B para decisões orientadas a dados.",
    ],
    tags: ["TypeScript", "NestJS", "AWS CDK", "ECS", "Lambda", "SQS", "SNS", "DynamoDB"],
  },
  {
    company: "NetProject",
    role: "Estagiário de Desenvolvimento",
    period: "jul/2023 – ago/2024",
    context: "Software de gestão de projetos.",
    highlights: [
      "Projetei um motor de cálculo em Go que propaga mudanças entre tarefas dependentes usando modelagem em grafos e ordenação topológica, processando projetos de até 100 tarefas em menos de 20 ms.",
    ],
    tags: ["Go", "Grafos", "Algoritmos", "Performance"],
  },
];

export const education = [
  {
    school: "PUC Minas",
    course: "Bacharelado em Ciência da Computação",
    period: "2021 – 2025",
    notes: ["Prêmio de Excelência Acadêmica no 1º e no 4º semestre"],
  },
  {
    school: "CEFET-MG",
    course: "Técnico em Eletrônica",
    period: "2017 – 2019",
    notes: [],
  },
];

export const languages = "Português (nativo) · Inglês (intermediário, B1) · Japonês (básico)";

export const featuredProjects = [
  {
    title: "Match My Pet",
    badge: "Produto próprio",
    imgUrl: matchMyPetImg,
    imgFit: "contain",
    summary:
      "App para tutores de cães e gatos encontrarem pets por perto, darem match e conversarem com outros tutores.",
    details:
      "Fiz o projeto inteiro, da arquitetura ao deploy: app em React Native e backend serverless em TypeScript na AWS, com toda a infraestrutura como código.",
    tags: ["React Native", "TypeScript", "NestJS", "AWS Lambda", "API Gateway", "SQS", "DynamoDB", "CDK"],
    links: [{ label: "Ver site", url: "https://matchmy.pet" }],
  },
  {
    title: "Imóveis Mendicino",
    badge: "Cliente",
    imgUrl: imoveisImg,
    imgFit: "contain",
    summary:
      "Site e API de uma imobiliária: catálogo de imóveis, captura de leads e envio automático de e-mails.",
    details:
      "Front-end em React e uma API REST serverless em NestJS rodando em Lambda, com DynamoDB em single-table design e e-mails via SES, tudo provisionado com AWS CDK.",
    tags: ["React", "TypeScript", "NestJS", "AWS Lambda", "DynamoDB", "SES", "CDK"],
    links: [{ label: "Ver site", url: "https://imoveismendicino.web.app" }],
  },
  {
    title: "BoiZap",
    badge: "Sistema distribuído",
    imgUrl: boizapImg,
    imgFit: "cover",
    summary:
      "Plataforma de bot para WhatsApp e Discord com comandos de IA para gerar texto, áudio e imagens.",
    details:
      "São 7 microsserviços em TypeScript, Python e Java que se comunicam por gRPC, com filas em Kafka e Redis. Uma rede descentralizada permite que computadores de usuários se conectem ao gateway e gerem imagens localmente. Deploy com Docker Swarm, CI/CD e versionamento semântico.",
    tags: ["TypeScript", "Python", "Java", "gRPC", "Kafka", "Redis", "MongoDB", "Docker Swarm"],
    links: [],
  },
  {
    title: "LightEM",
    badge: "Pesquisa",
    imgUrl: null,
    summary: "Biblioteca Python de entity matching: identifica registros da mesma entidade espalhados em várias tabelas.",
    details:
      "Avaliada em bases com mais de 100 mil registros, processando todas as entidades em menos de 4 minutos.",
    tags: ["Python", "Entity Matching", "Processamento de dados"],
    links: [],
  },
];

export const otherProjects = [
  {
    title: "TextLmRPG",
    description: "RPG de texto em que uma LLM é o mestre do jogo, com mundo persistente em grafo",
    imgUrl: null,
    projectUrl: null,
  },
  {
    title: "VideosCII",
    description: "Converte um vídeo inteiro em caracteres ASCII",
    imgUrl: videosciiImg,
    projectUrl: "https://github.com/PedroPampolini/Videoscii",
  },
  {
    title: "Purgatum",
    description: "Jogo desenvolvido em equipe na Unity",
    imgUrl: purgatumImg,
    projectUrl: "https://github.com/Bois-Barganhados-Studio/Purgatum-game",
  },
];

export const stack = [
  { group: "Linguagens", items: ["TypeScript", "JavaScript", "Go", "Python", "Java", "C"] },
  { group: "Backend & Arquitetura", items: ["Node.js", "NestJS", "Microsserviços", "Serverless", "gRPC", "REST", "Mensageria"] },
  { group: "Cloud & Dados", items: ["AWS Lambda", "ECS", "API Gateway", "SQS", "SNS", "SES", "DynamoDB", "MongoDB", "Redis", "Kafka"] },
  { group: "Infra & Ferramentas", items: ["AWS CDK", "Docker", "CI/CD", "Git", "Testes A/B"] },
  { group: "Front-end & Mobile", items: ["React", "React Native", "HTML", "CSS"] },
];

export const services = [
  {
    title: "Backends e APIs",
    description:
      "APIs escaláveis e serverless na AWS, integrações com serviços externos, filas e mensageria para sistemas que precisam aguentar volume.",
  },
  {
    title: "Apps mobile",
    description:
      "Aplicativos Android e iOS em React Native, do protótipo à publicação, com backend próprio.",
  },
  {
    title: "Sites e sistemas web",
    description:
      "Sites e sistemas sob medida, rápidos e preparados para aparecer no Google, como o da Imóveis Mendicino.",
  },
];
